// SPDX-License-Identifier: MIT
import { hash01 } from './rng.ts';
const fade = (t: number) => t * t * (3 - 2 * t);
/** Seeded 2D value noise in [0, 1). */
export function valueNoise2(x: number, y: number, seed = 0): number {
    const xi = Math.floor(x);
    const yi = Math.floor(y);
    const xf = fade(x - xi);
    const yf = fade(y - yi);
    const a = hash01(xi, yi, seed);
    const b = hash01(xi + 1, yi, seed);
    const c = hash01(xi, yi + 1, seed);
    const d = hash01(xi + 1, yi + 1, seed);
    return a + (b - a) * xf + (c - a) * yf + (a - b - c + d) * xf * yf;
}
/** Smooth 1D noise in [-1, 1], e.g. for camera shake. */
export function noise1(t: number, seed = 0): number {
    return valueNoise2(t, 0.5, seed) * 2 - 1;
}
